<template>
    <div v-if="this.show">
        <Spinner v-if="this.isLoading">{{ loadingText }}</Spinner>
        <div v-else>
            <div v-for="data of datas" :key="data">
                <h4 class="text-capitalize text-center my-5">{{ data.name }}</h4>
                <div class="row">
                    <div class="col-10 mx-auto">
                        <BarChart :data="data.chartData" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BarChart from "../components/Chart/BarChart.vue";
    import store from "node-back-client/src/store";
    import Spinner from "../components/Loaders/Spinner.vue";

    import { api } from "../services/api";
    export default {
        name: 'ServerEconomy',
        components: { BarChart, Spinner },
        methods: {
            async getserversEconomy() {
                this.datas = await api.getGoldEco()
            }
        },
        data() {
            return {
                isLoading: true,
                show: false,
                store: store,
                loadingText: "Generating graphs",
                goldCount: 0,
                datas: []
            }
        },
        async created() {
            this.show = true,
                this.isLoading = true;
            await this.getserversEconomy()
            this.isLoading = false;
            console.log(this.datas)
        }
    }
</script>
